/**
 * This file is only for the Webpack dev environment,
 * and won't (and shouldn't) be included in production
 */

import datePickerStyles from 'react-datetime/css/react-datetime.css'
import selectStyles from 'react-select/dist/react-select.css';
import toggleBlockStyles from 'react-toggle-block/dist/styles/react-toggle-block.css';
import grid from 'bootstrap-grid'
import oslIcons from 'oilservicelabs-icons'
import base from './base.scss'

export {
    datePickerStyles,
    selectStyles,
    toggleBlockStyles,
    grid,
    oslIcons,
    base
}



// WEBPACK FOOTER //
// ./web-app/styles/index.js